// extracted by mini-css-extract-plugin
module.exports = {"title":"_19blWf","chapterContent":"_3rPJxe"};